import InnerTransfer from './InnerTransfer';

export default InnerTransfer;
